{
  "google-salon-details-page": {
    "buttons": {
      "be-partner": "BE PARTNER",
      "request": "REQUEST"
    },
    "text": {
      "is-customer-question": "Are you customer of salon?",
      "is-customer-hint": "If you want online booking feature for the salon, please let us know and we will contact with salon owner.",
      "is-owner-question": "Are you salon owner?",
      "is-owner-hint": "Be a partner with us to discover our unlimited features with a big initial offer!",
      "request-sent": "YOUR REQUEST IS SENT"
    }
  }
}
